import { Box } from '@mafc/trolly';
import { ENotificationVariant } from '../types';
import * as S from './InlineNotification.styled';
import { ColorsMap, IconMap } from '../constants';

interface IProps {
  variant: ENotificationVariant;
  isShowAction?: boolean;
  actionLabel?: string;
  title?: string;
  description: string;
  showBorder?: boolean;
  onClick?: () => void;
}

const InlineNotification = ({
  variant,
  isShowAction = false,
  actionLabel,
  title,
  description,
  showBorder = false,
  onClick,
}: IProps): JSX.Element => {
  const Icon = IconMap[variant];
  const color = ColorsMap[variant];
  return (
    <S.InlineNotificationContainer variant={variant} showBorder={showBorder}>
      <S.IconBox>
        <Icon stroke="2" size="M" fill={color} />
      </S.IconBox>
      <Box ml={3}>
        {title && <Box fontWeight={7}>{title}</Box>}
        {description}
      </Box>
      {isShowAction && (
        <S.ButtonWrapper variant="link" onClick={onClick}>
          {actionLabel}
        </S.ButtonWrapper>
      )}
    </S.InlineNotificationContainer>
  );
};

export default InlineNotification;
